// AKM POC §7.1 — dışa aktarılan dosyanın başlıkları kullanıcının dilinde: sütun başlıkları tablonun kendi etiketlerinden,
// ortak etiketler (Hazırlayan, Sayfa, Toplam, süzgeç adları, gün durumları, hafta günleri) reportExport.labels.* çevirilerinden.
// Sunucu (ReportLabels.Common) aynı anahtarlarla Türkçe varsayılan taşır; gönderilmeyen anahtar oraya düşer.
import { ANOMALY_CODES, anomalyLabel } from './anomalyLabels';

export const REPORT_LABEL_KEYS = [
  'title', 'preparedBy', 'generatedAt', 'page', 'filters', 'total', 'noRecords', 'legend', 'signature',
  'filter.period', 'filter.employeeStatus', 'filter.userGroup', 'filter.department', 'filter.location', 'filter.workHour',
  'filter.person', 'filter.name', 'filter.status',
  'status.normal', 'status.absent', 'status.leave', 'status.partialLeave', 'status.holiday', 'status.halfDay',
  'status.missingExit', 'status.dayOff', 'status.workedOnDayOff',
  'weekday.0', 'weekday.1', 'weekday.2', 'weekday.3', 'weekday.4', 'weekday.5', 'weekday.6',
];

/** { [sütun adı]: başlık } — yalnız dize başlıklı ve tablodan hariç tutulmamış sütunlar. */
export function labelsFromColumns(columns) {
  const out = {};
  (columns || []).forEach((col) => {
    if (!col || typeof col !== 'object') return;
    if (typeof col.label !== 'string' || !col.label.trim()) return;
    if (col.options?.display === 'excluded') return;
    out[col.name] = col.label;
  });
  return out;
}

/** REPORT_LABEL_KEYS'in tamamı → t(`reportExport.labels.<anahtar>`). */
export function commonReportLabels(t) {
  const out = {};
  REPORT_LABEL_KEYS.forEach((key) => {
    out[key] = t(`reportExport.labels.${key}`);
  });
  return out;
}

/** Ortak + sütun etiketleri + başlık (+ sayfaya özgü ek etiketler). */
export function buildReportLabels(t, columns, title, extra = {}) {
  return {
    ...commonReportLabels(t),
    ...labelsFromColumns(columns),
    ...(title ? { title } : {}),
    ...extra,
  };
}

/** Gün durumu etiketleri ({ kod: ad } haritasından) → { 'status.<kod>': ad } — sunucu TaReportColumns.StatusLabel okur. */
export function statusReportLabels(statusLabels) {
  const out = {};
  Object.entries(statusLabels || {}).forEach(([code, label]) => {
    if (typeof label === 'string' && label.trim()) out[`status.${code}`] = label;
  });
  return out;
}

/** Puantaj anomali kodları → { 'anomaly.<kod>': ad } — sunucu AnomalyLabels okur (13 kod, web ile aynı çeviri). */
export function anomalyReportLabels(t) {
  const out = {};
  ANOMALY_CODES.forEach((code) => { out[`anomaly.${code}`] = anomalyLabel(t, code); });
  return out;
}
